import { NotificationIdentifier } from '@evorait/pace-core';

export namespace NotificationUtilities {
    export const compare = (first: NotificationIdentifier, second: NotificationIdentifier): boolean =>
        first.frontId === second.frontId && first.qmNum === second.qmNum && first.maNum === second.maNum;

    export const toString = (id: NotificationIdentifier, separator = '-'): string =>
        `Notification${separator}${id.frontId}${separator}${id.qmNum}${separator}${id.maNum}`;
}
